import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/client';
import MaintenancePage from '../pages/MaintenancePage';
import MaintenanceBanner from './MaintenanceBanner';

const BANNER_BODY_CLASS = 'has-maintenance-banner';

function MaintenanceGateWithBanner({ showBanner, children }) {
  useEffect(() => {
    if (showBanner && typeof document !== 'undefined') {
      document.body.classList.add(BANNER_BODY_CLASS);
    }
    return () => {
      document.body.classList.remove(BANNER_BODY_CLASS);
    };
  }, [showBanner]);

  return (
    <>
      <MaintenanceBanner />
      {children}
    </>
  );
}

/** Maršrutai, kurie turi būti prieinami ir maintenance režime (kad admin galėtų prisijungti). */
const MAINTENANCE_ALLOWED_PATHS = ['/login', '/login-2fa', '/forgot-password'];

/**
 * Jei įjungtas offline/atnaujinimo režimas, išoriniai lankytojai mato MaintenancePage.
 * Administratorius (prisijungęs su is_admin) ir /admin/* maršrutai visada mato pilną turinį.
 * /login, /login-2fa ir /forgot-password maintenance režime lieka atviri, kad admin galėtų prisijungti.
 */
function MaintenanceGate({ children }) {
  const location = useLocation();
  const hasToken = typeof window !== 'undefined' && !!localStorage.getItem('token');

  const { data: storeSettings } = useQuery({
    queryKey: ['store-settings'],
    queryFn: async () => {
      const res = await apiClient.get('/store-settings');
      return res.data;
    },
  });

  const { data: user } = useQuery({
    queryKey: ['auth-me'],
    queryFn: async () => {
      const res = await apiClient.get('/auth/me');
      return res.data;
    },
    enabled: hasToken,
    retry: false,
  });

  const maintenanceMode = !!(storeSettings && storeSettings.maintenance_mode);
  const isAdmin = !!(user && user.is_admin);
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAllowedPath = MAINTENANCE_ALLOWED_PATHS.includes(location.pathname);

  if (isAdminRoute || !maintenanceMode || isAdmin || isAllowedPath) {
    const showBanner = maintenanceMode && (isAdmin || isAdminRoute);
    if (showBanner) {
      return (
        <MaintenanceGateWithBanner showBanner={showBanner}>
          {children}
        </MaintenanceGateWithBanner>
      );
    }
    return children;
  }

  return <MaintenancePage />;
}

export default MaintenanceGate;
